import handler from 'api/handler'

const prefix = '/admin/authPageContent'

const methods = {
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  update: args => handler({ method: 'put', url: prefix + '/update', args, isFile: true })
}

export default methods
